// extracted by mini-css-extract-plugin
module.exports = {"flag":"CountryFlag_flag__3RvSq"};